import { render, staticRenderFns } from "./simpleHazardTypePicker.vue?vue&type=template&id=f0fd7056"
import script from "./simpleHazardTypePicker.vue?vue&type=script&lang=js"
export * from "./simpleHazardTypePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports